/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ wpm: NonNullable<unknown> }} Event_Ad_Rephrase_To_WpmInputs */

const en_event_ad_rephrase_to_wpm = /** @type {(inputs: Event_Ad_Rephrase_To_WpmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rephrase to ${i?.wpm} WPM`)
};

const fr_event_ad_rephrase_to_wpm = /** @type {(inputs: Event_Ad_Rephrase_To_WpmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reformuler a ${i?.wpm} WPM`)
};

const de_event_ad_rephrase_to_wpm = /** @type {(inputs: Event_Ad_Rephrase_To_WpmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Umformulieren zu ${i?.wpm} WPM`)
};

const it_event_ad_rephrase_to_wpm = /** @type {(inputs: Event_Ad_Rephrase_To_WpmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Riformulare in ${i?.wpm} WPM`)
};

const ru_event_ad_rephrase_to_wpm = /** @type {(inputs: Event_Ad_Rephrase_To_WpmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Перефразируйте до ${i?.wpm} слов в минуту`)
};

const es_event_ad_rephrase_to_wpm = /** @type {(inputs: Event_Ad_Rephrase_To_WpmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reformular a ${i?.wpm} WPM`)
};

const zh_cn2_event_ad_rephrase_to_wpm = /** @type {(inputs: Event_Ad_Rephrase_To_WpmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`改写为${i?.wpm} WPM`)
};

const ja_event_ad_rephrase_to_wpm = /** @type {(inputs: Event_Ad_Rephrase_To_WpmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.wpm} WPMに言い換える`)
};

const hi_event_ad_rephrase_to_wpm = /** @type {(inputs: Event_Ad_Rephrase_To_WpmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इसे ${i?.wpm} WPM में पुनः लिखें`)
};

const pt_pt2_event_ad_rephrase_to_wpm = /** @type {(inputs: Event_Ad_Rephrase_To_WpmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reformule para ${i?.wpm} WPM`)
};

/**
* | output |
* | --- |
* | "Rephrase to {wpm} WPM" |
*
* @param {Event_Ad_Rephrase_To_WpmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_rephrase_to_wpm = /** @type {((inputs: Event_Ad_Rephrase_To_WpmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Rephrase_To_WpmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_ad_rephrase_to_wpm(inputs)
	if (locale === "de") return de_event_ad_rephrase_to_wpm(inputs)
	if (locale === "it") return it_event_ad_rephrase_to_wpm(inputs)
	if (locale === "ru") return ru_event_ad_rephrase_to_wpm(inputs)
	if (locale === "es") return es_event_ad_rephrase_to_wpm(inputs)
	if (locale === "zh-CN") return zh_cn2_event_ad_rephrase_to_wpm(inputs)
	if (locale === "ja") return ja_event_ad_rephrase_to_wpm(inputs)
	if (locale === "hi") return hi_event_ad_rephrase_to_wpm(inputs)
	if (locale === "pt-PT") return pt_pt2_event_ad_rephrase_to_wpm(inputs)
	return en_event_ad_rephrase_to_wpm(inputs)
});